import {
  APEX_CLASS,
  APEX_TRIGGER,
  APPROVAL_PROCESS,
  FIELD,
  FLOW,
  OBJECT,
  PROCESS_BUILDER_FLOW,
  VALIDATION_RULE,
  WORKFLOW_RULE,
  LAYOUT,
  RECORD_TYPE,
} from '@server/parser';
import { ConfigurationItem } from '../../parser/ParserTypes';

export enum SearchType {
  apiNameAndLabel = 'NAME_LABEL_SEARCH',
  content = 'CONTENT_SEARCH',
}

export type SearchResponseWithConfigurationItems = {
  [APEX_CLASS]: ConfigurationItem[];
  [APEX_TRIGGER]: ConfigurationItem[];
  [APPROVAL_PROCESS]: ConfigurationItem[];
  [FIELD]: ConfigurationItem[];
  [FLOW]: ConfigurationItem[];
  [OBJECT]: ConfigurationItem[];
  [PROCESS_BUILDER_FLOW]: ConfigurationItem[];
  [VALIDATION_RULE]: ConfigurationItem[];
  [WORKFLOW_RULE]: ConfigurationItem[];
  [LAYOUT]: ConfigurationItem[];
  [RECORD_TYPE]: ConfigurationItem[];
  [type: string]: ConfigurationItem[];
};
